import React, { Component } from 'react';
import { Button, ButtonToolbar, Form, FormGroup, ControlLabel, Modal, FormControl, Row, Col, HelpBlock } from 'react-bootstrap';
import DatePicker from 'react-16-bootstrap-date-picker';
import Select from 'react-select';
import { Map, TileLayer, Circle, FeatureGroup } from 'react-leaflet';
import { EditControl } from 'react-leaflet-draw';

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';


export class MessageForm extends Component {
    renderLines(messageSelected, availableLines) {
        //If it is a transport authority
        if (this.props.isAT) {
            //If no provider is selected, display no lines
            if (undefined === messageSelected.provider || '' === messageSelected.provider) {
                return (
                    <FormControl componentClass="select" value={typeof messageSelected.line !== 'undefined' ? messageSelected.line.id : ""} onChange={(e) => this.props.onChangeValue(e, 'line')}>
                        <option key={`line-provider-undefined`}>Selecione um operador</option>);
                    </FormControl>
                );
            }
            //Find out which provider is selected and which lines belong to it
            let selectedProvider = this.props.availableProviders.filter(p => parseInt(p.id, 10) === parseInt(messageSelected.provider.id, 10))[0];
            let providerLines = this.props.availableLines.filter(l => l.provider.id === parseInt(selectedProvider.id, 10));
            return (
                <FormControl componentClass="select" value={typeof messageSelected.line !== 'undefined' ? messageSelected.line.id : ""} onChange={(e) => this.props.onChangeValue(e, 'line')}>
                    <option key={`line-undefined`}>Selecione uma linha</option>
                    {
                        providerLines.sort((a, b) => a.goName !== b.goName ? a.goName < b.goName ? -1 : 1 : 0).map((line, idx) =>
                            <option key={`line-${idx}`} value={line.id}>{`${line.goName} (${line.code})`}</option>
                        )
                    }
                </FormControl>
            );
        }

        if(typeof undefined === messageSelected.line || "" === messageSelected.line) {
            messageSelected.line = [];
        }

        //If it is a provider, availableLines will only have the provider lines, so no special filtering is necessary
        return (
            <Select
                className="custom-multiselect"
                placeholder='Selecione uma ou mais linhas...'
                value={messageSelected.line.map((line) => ({
                    ...line, 
                    value: line.id,
                    label: `${line.code} | ${line.goName}`
                }))}
                isMulti={true}
                onChange={(e) => this.props.onChangeValue(e, 'line')}
                getOptionValue={value => value.id}
                getOptionLabel={label => `${label.code} | ${label.goName}`}
                options={availableLines
                    .sort((a, b) => {
                        const extractParts = (code) => {
                            const match = code.match(/^(\d+)([A-Za-z]*)$/);
                            return match ? [parseInt(match[1], 10), match[2]] : [0, ""];
                        };

                        const [numA, suffixA] = extractParts(a.code);
                        const [numB, suffixB] = extractParts(b.code);

                        return numA !== numB ? numA - numB : suffixA.localeCompare(suffixB);
                    })
                    .map((line) => ({
                        ...line,
                        value: line.id,
                        label: `${line.code} | ${line.goName}`
                    })
                )}
            />
        );
    }

    renderPathStops(messageSelected, availablePathStops) {
        //If no line is selected, display no stops
        if (messageSelected.line === undefined || messageSelected.line.length === 0) {
            return (
                <FormControl componentClass="select" value={typeof messageSelected.stop !== 'undefined' ? messageSelected.stop.id : ""} onChange={(e) => this.props.onChangeValue(e, 'stop')}>
                    <option key={`stop-line-undefined`}>Selecione uma linha</option>);
                </FormControl>
            );
        }

        if(typeof messageSelected.stop === undefined || messageSelected.stop === "") {
            messageSelected.stop = [];
        }

        let lineStops = [];
        //Filter by pathStops belonging to line paths and adding the distinct stops that will be shown to the user to the lineStops array
        availablePathStops.forEach(ps => {
            let isStopAlreadyInLineStops = lineStops.some(s => s.id === ps.stop.id);
            let isStopInAnyLinePath = messageSelected.line.some(line => line.paths.some(p => p.id === ps.path.id));

            if (!isStopAlreadyInLineStops && isStopInAnyLinePath) {
                lineStops.push(ps.stop);
            }
        });
        return (
            <Select
                className="custom-multiselect"
                placeholder='Selecione uma ou mais paragens...'
                value={messageSelected.stop.map((stop) => ({
                    ...stop,
                    value: stop.id,
                    label: `${stop.name} (${stop.code})`
                }))}
                isMulti={true}
                onChange={(e) => this.props.onChangeValue(e, 'stop')}
                getOptionValue={value => value.id}
                getOptionLabel={label => `${label.name} (${label.code})`}
                options={ lineStops.sort((a, b) => this.sortData(a, b, "name")) }
            />
        );
    }

    sortData(a, b, sortBy) {
        return a[sortBy] !== b[sortBy] ? a[sortBy] < b[sortBy] ? -1 : 1 : 0;
    }

    calculateBounds(messageSelected) {
        if (0 !== messageSelected.coordX && 0 !== messageSelected.coordY) {
            return [{ lat: messageSelected.coordX, lng: messageSelected.coordY }];
        }

        return [{ lat: 39.69484, lng: -8.13031}];
    }

    calculateCircleCenter(messageSelected) {
        if (0 !== messageSelected.coordX && 0 !== messageSelected.coordY) {
            return [messageSelected.coordX, messageSelected.coordY];
        }

        return [0, 0];
    }

    render() {
        let { title, messageSelected, availableLines, availablePathStops, availablePlatforms, isAT, availableProviders, titleInputError, startDateInputError, endDateInputError, platformInputError, typeInputError, textInputError
        } = this.props;

        const toolbarOptions = [
            [{ 'header': 1 }, { 'header': 2 }], 
            ['bold', 'italic', 'underline'],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            ['link', 'image'],
            ['clean']
        ];

        //Needed for react-select to have the complete current list of message.Platforms
        let selectDefaultValue = [];
        let selectTypeDefaultValue = [];
        if (undefined !== messageSelected) {

            messageSelected.platforms.forEach(p => {
                selectDefaultValue.push(p);
            });

            let aux = { value: messageSelected.type, label: `${messageSelected.type}` };

            selectTypeDefaultValue.push(aux);
        }

        return (
            typeof messageSelected !== 'undefined'
                ?
                <Modal bsSize={"large"} show={this.props.show}>
                    <Modal.Header>
                        <Modal.Title>
                            {title}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            {
                                isAT && availableProviders.length > 0 ?
                                    <FormGroup controlId="formProvider">
                                        <ControlLabel>Operador</ControlLabel>
                                        <FormControl componentClass="select" value={typeof messageSelected.provider !== 'undefined' ? messageSelected.provider.id : ""} onChange={(e) => this.props.onChangeValue(e, 'provider')}>
                                            <option key={`provider-undefined`}>Selecione um operador</option>
                                            {
                                                availableProviders.sort((a, b) => a.name !== b.name ? a.name < b.name ? -1 : 1 : 0).map((provider, idx) =>
                                                    <option key={`provider-${idx}`} value={provider.id}>{provider.name}</option>
                                                )
                                            }
                                        </FormControl>
                                    </FormGroup>
                                    :
                                    null
                            }

                            <Row>
                                <Col sm={6}>
                                    <FormGroup controlId="formLine">
                                        <ControlLabel className="message-form-label">
                                            <span>Linha</span>
                                            <span className="message-form-span"
                                                onClick={() => this.props.onChangeValue(availableLines, "line", true)}>
                                                Selecionar tudo
                                            </span>
                                        </ControlLabel>
                                        {this.renderLines(messageSelected, availableLines)}
                                    </FormGroup>
                                </Col>
                                <Col sm={6}>
                                    <FormGroup controlId="formStop">
                                        <ControlLabel className="message-form-label">
                                            <span>Paragens</span>
                                            <span className="message-form-span"
                                                onClick={() => this.props.onChangeValue(availablePathStops, "stop", true)}>
                                                Selecionar tudo
                                            </span>
                                        </ControlLabel>
                                        {this.renderPathStops(messageSelected, availablePathStops)}
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col sm={6}>
                                    <FormGroup controlId="formPlataforma" validationState={platformInputError}>
                                        <ControlLabel className="message-form-label">
                                            <span>Plataforma</span>
                                            <span className="message-form-span"
                                                onClick={() => this.props.onChangeValue(availablePlatforms, "platform", true)}>
                                                Selecionar tudo
                                            </span>
                                        </ControlLabel>
                                        <Select
                                            className="custom-multiselect"
                                            placeholder='Selecione uma ou mais plataformas...'
                                            value={selectDefaultValue}
                                            isMulti={true}
                                            onChange={(e) => this.props.onChangeValue(e, 'platform')}
                                            getOptionValue={value => value.id}
                                            getOptionLabel={label => `${label.name}`}
                                            options={availablePlatforms.sort((a, b) => a.name !== b.name ? a.name < b.name ? -1 : 1 : 0)}
                                        />
                                        {platformInputError !== null
                                            ? <HelpBlock> Necessita de selecionar pelo menos uma plataforma. </HelpBlock>
                                            : null
                                        }
                                    </FormGroup>
                                </Col>
                                <Col sm={6}>
                                    <FormGroup controlId="formType" validationState={typeInputError}>
                                        <ControlLabel>Tipo</ControlLabel>
                                        <Select
                                            className="custom-multiselect"
                                            placeholder='Selecione um tipo de mensagem...'
                                            defaultValue={selectTypeDefaultValue}
                                            isMulti={false}
                                            onChange={(e) => this.props.onChangeValue(e, 'type')}
                                            options={[
                                                    { value: 'Aviso', label: 'Aviso' },
                                                ]
                                            }
                                        />
                                        {typeInputError !== null
                                            ? <HelpBlock> Este campo não pode estar vazio. </HelpBlock>
                                            : null
                                        }
                                    </FormGroup>  
                                </Col>
                            </Row>

                            <Row>
                                <Col sm={12}>
                                    <FormGroup controlId="formTitle" validationState={titleInputError}>
                                        <ControlLabel>Titulo</ControlLabel>
                                        <FormControl
                                            type="text"
                                            value={messageSelected.title}
                                            placeholder="Introduza um titulo"
                                            onChange={(e) => this.props.onChangeValue(e, 'title')}
                                        />
                                        {titleInputError !== null
                                            ? <HelpBlock> Este campo não pode estar vazio. </HelpBlock>
                                            : null}
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row style={{height: "250px"}} >
                                <Col sm={12}>
                                    <FormGroup controlId="formText" validationState={textInputError}>
                                        <ControlLabel>Mensagem</ControlLabel>
                                            <ReactQuill style={{height: "150px"}}  theme="snow" modules={ {toolbar: toolbarOptions} }
                                                value={messageSelected.text}  onChange={(e) => this.props.onChangeValue(e, 'text')} />
                                            {textInputError !== null
                                                ? <HelpBlock> Este campo não pode estar vazio. </HelpBlock>
                                                : null}
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col sm={6}>
                                    <FormGroup controlId="formVersion">
                                        <ControlLabel>Versão</ControlLabel>
                                        <FormControl
                                            type="text"
                                            value={messageSelected.version}
                                            placeholder="Introduza a versão"
                                            onChange={(e) => this.props.onChangeValue(e, 'version')}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm={6}>
                                    <FormGroup controlId="formHttpLink">
                                        <ControlLabel>Hiperligação</ControlLabel>
                                        <FormControl
                                            type="text"
                                            value={messageSelected.httpLink}
                                            placeholder="Introduza a hiperligação"
                                            onChange={(e) => this.props.onChangeValue(e, 'httpLink')}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col sm={6}>
                                    <FormGroup controlId="formStartDate" validationState={startDateInputError}>
                                        <ControlLabel>Data de Início</ControlLabel>
                                        <DatePicker
                                            id="startDateDatePicker"
                                            dateFormat="DD/MM/YYYY"
                                            value={messageSelected.startDate}
                                            placeholder="Introduza a Data de Início"
                                            onChange={(e) => {
                                                const selectedDate = new Date(e);
                                                selectedDate.setHours(0, 0, 0, 0);
                                                this.props.onChangeValue(selectedDate.toISOString(), 'startDate')} 
                                            }/>
                                        {startDateInputError !== null
                                            ? <HelpBlock> Valor de data inválido. Este campo não pode estar vazio. </HelpBlock>
                                            : null
                                        }
                                    </FormGroup>
                                </Col>
                                <Col sm={6}>
                                    <FormGroup controlId="formEndDate" validationState={endDateInputError}>
                                        <ControlLabel>Data de Fim</ControlLabel>
                                        <DatePicker
                                            id="endDateDatePicker"
                                            dateFormat="DD/MM/YYYY"
                                            value={messageSelected.endDate}
                                            placeholder="Introduza a Data de Fim"
                                            onChange={(e) => {
                                                const selectedDate = new Date(e);
                                                selectedDate.setHours(23, 59, 59, 999);
                                                this.props.onChangeValue(selectedDate.toISOString(), 'endDate')}
                                            }/>
                                        {endDateInputError !== null
                                            ? <HelpBlock> Valor de data inválido. Verifique que a data não é anterior à data inicial. </HelpBlock>
                                            : null
                                        }
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={4}>
                                    <FormGroup controlId="formCoordX">
                                        <ControlLabel>Coordenada X</ControlLabel>
                                        <FormControl
                                            type="number"
                                            value={messageSelected.coordX}
                                            disabled
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm={4}>
                                    <FormGroup controlId="formCoordY">
                                        <ControlLabel>Coordenada Y</ControlLabel>
                                        <FormControl
                                            type="number"
                                            value={messageSelected.coordY}
                                            disabled
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm={4}>
                                    <FormGroup controlId="formRadius">
                                        <ControlLabel>Raio</ControlLabel>
                                        <FormControl
                                            type="number"
                                            value={messageSelected.radius}
                                            disabled
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <FormGroup controlId="formMap">
                                <Map className="map-container" minZoom={6} maxZoom={15} zoom={5}
                                    bounds={this.calculateBounds(messageSelected)} ondblclick={(e) => this.props.onChangeValue(e, 'dblClick')}>
                                    <TileLayer
                                        attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"/>

                                    <FeatureGroup>
                                        <EditControl
                                            position='topright'
                                            onEdited={(e) => this.props.onChangeValue(e, 'circleEdited')}
                                            draw={{
                                                polyline: false,
                                                polygon: false,
                                                rectangle: false,
                                                marker: false,
                                                circlemarker: false,
                                                circle: false,
                                            }}
                                            edit={{
                                                remove: false
                                            }}
                                        />
                                        <Circle center={this.calculateCircleCenter(messageSelected)} radius={messageSelected.radius} />
                                    </FeatureGroup>
                                </Map>
                            </FormGroup>
                        </Form>

                        <ButtonToolbar>
                            <Button onClick={this.props.onSave}> GUARDAR ALTERAÇÕES </Button>
                            <Button onClick={this.props.onHide}> CANCELAR </Button>
                        </ButtonToolbar>

                    </Modal.Body>
                </Modal >
                : null
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/messages/MessageForm.js